function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.405 1.414h30.778V54.89H12.405z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.685 3.69h26.218v51.2H14.685z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.964 5.965h21.658v21.618H16.964z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.654 5.965v9.103h-9.69v2.275h9.69v10.24h2.28v-10.24h9.69v-2.275h-9.69V5.965zM19.244 30.997a1.139 1.139 0 11-2.278-.002 1.139 1.139 0 012.278.002z"
}));

var SvgDoor = function SvgDoor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Door.1e1168e3.svg";
export { ForwardRef as ReactComponent };